<template>
  <EContent
    v-if="show"
    :country-name="countryName"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { trackImpression, PAGE_SERP, TYPE_ENTITY } from '~~/search/common/js/client/analytics/rich-content';

export const TRACK_ID = 'tree_project';

export default {
  name: 'ETreeProjectTracker',
  components: {
    EContent: async () => import(
      /* webpackChunkName: "tree-project-tracker" */
      './tree-tracker.vue'
    ),
  },
  props: {
    countryName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('goodall', ['getExperiment']),
    show() {
      return this.getExperiment('sea-web-entity-tree-tracker') === 'enabled';
    },
  },
  mounted() {
    trackImpression({
      name: TRACK_ID,
      page: PAGE_SERP,
      type: TYPE_ENTITY,
      once: true,
    });
  },
};
</script>
